import { NgClass, TitleCasePipe } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { NbTooltipModule } from '@nebular/theme';
import { STATUSES } from '../../constants/general-constants';

@Component({
  selector: 'app-status-light',
  templateUrl: './status-light.component.html',
  styleUrls: ['./status-light.component.css'],
  imports: [NbTooltipModule, NgClass, TitleCasePipe]
})
export class StatusLightComponent implements OnInit {
  @Input() public value: string;
  @Input() public rowData: any;
  public renderValue: string;
  public statuses = STATUSES;

  constructor() {}

  public ngOnInit() {
    if (this.value) {
      this.renderValue = this.value;
    }
  }
}
